/**
 * AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
 * Generated by: scripts/generate-template-loaders.js
 * Source files:
 *   - classic.njk
 *   - classic.css
 */

export const CLASSIC_TEMPLATE = `{% if isA4 %}
  <div
    class="a4-container">
    <!-- Header Row (50/50 Split) -->
    <div class="a4-hdr-row">
      <div class="a4-hdr-left">
        {% if logoUrl %}
          <img class="a4-hdr-logo-img" src="{{ logoUrl }}" alt="{{ storeName }}"/>
        {% endif %}
      </div>
      <div class="a4-hdr-right-store">
        <div class="store-title">{{ storeName }}</div>
        {% if address %}<p>{{ address | replace('\\n', ', ') }}</p>{% endif %}
        {% if phone %}
          <p>{{ phone }}{% if whatsapp %} / {{ whatsapp }}{% endif %}</p>
        {% endif %}
        {% if email %}<p>{{ email }}</p>{% endif %}
        {% if website %}<p>{{ website }}</p>{% endif %}
      </div>
    </div>

    <!-- Horizontal Metadata Row -->
    <div class="a4-meta-row">
      <div class="a4-meta-col">
        <span class="a4-meta-lbl">Invoice No</span>
        <strong class="a4-meta-val">{{ orderNo }}</strong>
      </div>
      <div class="a4-meta-col">
        <span class="a4-meta-lbl">Date / Time</span>
        <strong class="a4-meta-val">{{ dateStr }} - {{ timeStr }}</strong>
      </div>
      <div class="a4-meta-col">
        <span class="a4-meta-lbl">Cashier</span>
        <strong class="a4-meta-val">{{ cashier or "-" }}</strong>
      </div>
      <div class="a4-meta-col text-right">
        <span class="a4-meta-lbl">Status</span>
        <span class="status-badge-a4 {{ orderStatus | lower }}">{{ orderStatus or "N/A" }}</span>
      </div>
    </div>
    <!-- Customer Cards Info -->
    <div class="a4-cust-card">
      <div class="a4-cust-grid">
        <span class="a4-cust-lbl">Customer Name:</span>
        <span class="a4-cust-val">{{ customerName }}</span>
        {% if customerAddress %}
          <span class="a4-cust-lbl">Address:</span>
          <span class="a4-cust-val">{{ customerAddress }}</span>
        {% endif %}
        {% if customerPhone %}
          <span class="a4-cust-lbl">Contact:</span>
          <span class="a4-cust-val">{{ customerPhone }}</span>
        {% endif %}
        {% if customerEmail %}
          <span class="a4-cust-lbl">Email:</span>
          <span class="a4-cust-val" style="text-transform: none;">{{ customerEmail }}</span>
        {% endif %}
        {% if vehicleNo %}
          <span class="a4-cust-lbl">Vehicle No:</span>
          <span class="a4-cust-val">{{ vehicleNo }}</span>
        {% endif %}
      </div>
    </div>
    <!-- Optional Reason / Notes -->
    {% if orderNote %}
      <div style="margin: 12px 0 14px 0; background: #f8f8f8; border: 1px solid #ddd; border-left: 4px solid #333; padding: 10px
          12px; font-size: 12px; color: #333; line-height: 1.5;">
        <strong style="font-size: 10px; letter-spacing: 1px; text-transform: uppercase; display: block; margin-bottom: 4px;">
        Reason / Notes</strong>
        {{ orderNote }}
      </div>
    {% endif %}
    <!-- Items Table -->
    <table class="a4-items-table">
      <thead>
        <tr>
          <th class="a4-col-no">NO</th>
          <th class="a4-col-desc">ITEM DESCRIPTION</th>
          <th class="a4-col-price">PRICE</th>
          <th class="a4-col-qty">QUANTITY</th>
          <th class="a4-col-amount">AMOUNT</th>
        </tr>
      </thead>
      <tbody>
        {% set itemIndex = 1 %}
        {% for item in productItems %}
          <tr class="a4-item-row">
            <td class="a4-col-no">{{ itemIndex }}</td>
            <td class="a4-desc-cell">
              {{ item.product_name or item.item_name or "Product" }}
              {% if item.batch_no %}
                <small>({{ item.batch_no }})</small>
              {% endif %}
            </td>
            <td class="a4-price-cell">{{ item.price | formatPrice }}</td>
            <td class="a4-qty-cell">{{ item.quantity }}</td>
            <td class="a4-amount-cell">{{ item.total_price | formatPrice }}</td>
          </tr>
          {% if item.discount_amount > 0 %}
            <tr class="a4-item-disc-row">
              <td></td>
              <td colspan="3" class="a4-item-disc-label">Discount:</td>
              <td class="a4-item-disc-val">- {{ item.discount_amount | formatPrice }}</td>
            </tr>
          {% endif %}
          {% set itemIndex = itemIndex + 1 %}
        {% endfor %}
        {% for item in serviceItems %}
          <tr class="a4-item-row">
            <td class="a4-col-no">{{ itemIndex }}</td>
            <td class="a4-desc-cell">
              {{ item.product_name or item.item_name or "Service" }}
            </td>
            <td class="a4-price-cell">{{ item.price | formatPrice }}</td>
            <td class="a4-qty-cell">{{ item.quantity }}</td>
            <td class="a4-amount-cell">{{ item.total_price | formatPrice }}</td>
          </tr>
          {% if item.discount_amount > 0 %}
            <tr class="a4-item-disc-row">
              <td></td>
              <td colspan="3" class="a4-item-disc-label">Discount:</td>
              <td class="a4-item-disc-val">- {{ item.discount_amount | formatPrice }}</td>
            </tr>
          {% endif %}
          {% set itemIndex = itemIndex + 1 %}
        {% endfor %}
      </tbody>
    </table>
    {% if hasReturns %}
      <div class="a4-sec-title" style="margin-top: 14px;">Returns / Exchanges</div>
      <table class="a4-items-table">
        <thead>
          <tr>
            <th class="a4-col-no">NO</th>
            <th class="a4-col-desc">ITEM DESCRIPTION</th>
            <th class="a4-col-qty">QTY</th>
            <th class="a4-col-price">TYPE</th>
            <th class="a4-col-amount">AMOUNT</th>
          </tr>
        </thead>
        <tbody>
          {% set returnIndex = 1 %}
          {% for ret in returns %}
            {% for item in ret.items %}
              <tr class="a4-item-row">
                <td class="a4-col-no">{{ returnIndex }}</td>
                <td class="a4-desc-cell">
                  {{ item.product_name }}
                  {% if item.is_tempory_item %}
                    <span class="a4-badge-exchange">EXCHANGE</span>
                  {% endif %}
                </td>
                <td class="a4-qty-cell">{{ item.quantity }}</td>
                <td class="a4-price-cell">{{ item.return_type_name or "-" }}</td>
                <td class="a4-amount-cell">{{ item.total_refund | formatPrice }}</td>
              </tr>
              {% set returnIndex = returnIndex + 1 %}
            {% endfor %}
          {% endfor %}
        </tbody>
      </table>
      <br/>
      {% for ret in returns %}
        <div class="a4-return-ref">
          <strong>Return {{ ret.return_no }}</strong>- {{ ret.refund_type_name or "Return" }}-
          <span style="font-family: monospace;">{{ currency }}
            {{ ret.total_returned | formatPrice }}</span>
        </div>
      {% endfor %}
    {% endif %}
    <!-- Modern Summary Section -->
    <div class="a4-summary-container">
      <div class="a4-summary-left-card">
        <div class="a4-info-row">
          <span class="a4-info-label">Total Items Count</span>
          <span class="a4-info-value">{{ totalItemsCount }} Item(s)</span>
        </div>
        <div class="a4-info-row">
          <span class="a4-info-label">Payment Mode</span>
          <span class="a4-info-value payment-badge">{{ paymentMethodName or "N/A" }}</span>
        </div>
        <div class="a4-info-row">
          <span class="a4-info-label">Order Status</span>
          <span class="a4-info-value status-badge-a4 {{ orderStatus | lower }}">{{ orderStatus or "N/A" }}</span>
        </div>
      </div>
      <div class="a4-summary-right-totals">
        <div class="a4-total-row">
          <span class="a4-total-lbl">Sub Total</span>
          <span class="a4-total-val">{{ (productSubtotal + serviceTotal) | formatPrice }}</span>
        </div>
        {% if showDisc %}
          <div class="a4-total-row">
            <span class="a4-total-lbl">Discount</span>
            <span class="a4-total-val">- {{ discountAmount | formatPrice }}</span>
          </div>
        {% endif %}
        {% if showExch %}
          <div class="a4-total-row">
            <span class="a4-total-lbl">Exchange Disc.{% if exchangeSourceNo %}
                <em class="a4-exch-src">(from {{ exchangeSourceNo }})</em>
              {% endif %}
            </span>
            <span class="a4-total-val">- {{ exchangeAmount | formatPrice }}</span>
          </div>
        {% endif %}
        {% if showChg %}
          <div class="a4-total-row">
            <span class="a4-total-lbl">Other Charges</span>
            <span class="a4-total-val">{{ otherCharges | formatPrice }}</span>
          </div>
        {% endif %}
        <div class="a4-grand-total-row">
          <span class="a4-grand-lbl">GRAND TOTAL</span>
          <span class="a4-grand-val">{{ currency }}
            {{ grandTotal | formatPrice }}</span>
        </div>
        <div style="border-top: 1px dashed #dee2e6; margin-top: 5px; padding-top: 5px;"></div>
        <div class="a4-total-row" style="font-weight: 600;">
          <span class="a4-total-lbl">Total Paid (Cash/Card/Bank)</span>
          <span class="a4-total-val">{{ currency }}
            {{ paidAmount | formatPrice }}</span>
        </div>
        {% if chequePaid > 0 %}
          <div class="a4-total-row" style="font-weight: 600; color: #495057;">
            <span class="a4-total-lbl">Cheques (Uncleared)</span>
            <span class="a4-total-val">{{ currency }}
              {{ chequePaid | formatPrice }}</span>
          </div>
        {% endif %}
        {% if creditAmount > 0 %}
          <div class="a4-total-row" style="font-weight: 700; color: #d9534f;">
            <span class="a4-total-lbl">Credit (Balance Due)</span>
            <span class="a4-total-val">{{ currency }}
              {{ creditAmount | formatPrice }}</span>
          </div>
        {% endif %}
      </div>
    </div>
    <!-- Payments Logged Section (List Table) -->
    {% if payments.length > 0 %}
      <div class="a4-payments-section">
        <div class="a4-sec-title">Payments Logged</div>
        <table class="a4-payments-table">
          <thead>
            <tr>
              <th style="width: 20%;">Date & Time</th>
              <th style="width: 50%;">Method & Details</th>
              <th style="width: 15%; text-align: right;">Amount</th>
              <th style="width: 15%;">Note</th>
            </tr>
          </thead>
          <tbody>
            {% for p in payments %}
              <tr>
                <td style="font-size: 0.9em; white-space: nowrap;">{{ (p.created_at or p.payment_date or dateStr) | dateTimeFormat }}</td>
                <td>
                  <strong style="text-transform: uppercase;">{{ p.payment_method_name or p.payment_method_code or "Payment" }}</strong>
                  <div style="font-size: 0.85em; margin-top: 4px; color: #555; line-height: 1.4;">
                    {% if p.payment_method_code == "cheque" or p.cheque_no %}
                      <div>
                        <strong>Cheque No:</strong>
                        {{ p.cheque_no or "-" }}</div>
                      <div>
                        <strong>Bank Name:</strong>
                        {{ p.bank_name or p.cheque_bank_name or "-" }}</div>
                      <div>
                        <strong>Cheque Date:</strong>
                        {{ p.cheque_date or "-" }}</div>
                      {% if p.deposit_bank_name %}
                        <div>
                          <strong>Target Bank:</strong>
                          {{ p.deposit_bank_name }}
                          {% if p.deposit_account_number %}({{ p.deposit_account_number }}){% endif %}
                        </div>
                      {% endif %}
                    {% elif p.payment_method_code == "card" or p.payment_method_code == "bank_transfer" or p.transaction_no %}
                      {% if p.transaction_no %}
                        <div>
                          <strong>Tx Ref:</strong>
                          {{ p.transaction_no }}</div>
                      {% endif %}
                      {% if p.bank_name or p.deposit_bank_name %}
                        <div>
                          <strong>Bank:</strong>
                          {{ p.bank_name or p.deposit_bank_name }}
                          {% if p.deposit_account_number %}({{ p.deposit_account_number }}){% endif %}
                        </div>
                      {% endif %}
                    {% else %}
                      {% if p.note %}
                        <div>Ref: {{ p.note }}</div>
                      {% endif %}
                    {% endif %}
                  </div>
                </td>
                <td style="text-align: right; font-weight: bold; font-family: monospace;">{{ currency }}
                  {{ p.amount | formatPrice }}</td>
                <td style="font-size: 0.9em; color: #666;">{{ p.note or "-" }}</td>
              </tr>
            {% endfor %}
          </tbody>
        </table>
      </div>
    {% endif %}
    <!-- Signature Section -->
    <div class="a4-signature-section">
      <div class="a4-sig-block">
        <div class="a4-sig-line"></div>
        <div class="a4-sig-label">Customer Signature</div>
      </div>
      <div class="a4-sig-block">
        <div class="a4-sig-line"></div>
        <div class="a4-sig-label">Authorized Signature</div>
      </div>
    </div>
    <!-- Bottom Footer -->
    <div class="a4-ftr">
      <div class="a4-ftr-thank">Thank you for business, Visit us again!</div>
      <div class="a4-ftr-powered">Powered by TaproDev POS</div>
    </div>
  </div>
{% else %}
  <div class="wrap">
    {% if orderStatus %}
      <div class="status-badge">{{ orderStatus }}</div>
    {% endif %}
    <div class="hdr">
      {% if logoUrl %}
        <div><img class="hdr-logo" src="{{ logoUrl }}" alt="{{ storeName }}"/></div>
      {% endif %}
      <div class="store-name">{{ storeName }}</div>
      {% if address %}
        <p>{{ address | replace('\\n', ', ') }}</p>
      {% endif %}
      {% if phone %}
        <p>{{ phone }}
          {% if whatsapp %}
            <span>
              / {{ whatsapp }}</span>
          {% endif %}
        </p>
      {% endif %}
    </div>
    <hr class="hdr-divider"/>
    <table class="meta-table">
      <tbody>
        <tr>
          <td class="meta-lbl">Invoice No:</td>
          <td class="meta-val">{{ orderNo }}</td>
        </tr>
        <tr>
          <td class="meta-lbl">Invoice Date</td>
          <td class="meta-val">{{ dateStr }}</td>
        </tr>
        <tr>
          <td class="meta-lbl">Invoice Time</td>
          <td class="meta-val">{{ timeStr }}</td>
        </tr>
        <tr>
          <td class="meta-lbl">Cashier:</td>
          <td class="meta-val">{{ cashier }}</td>
        </tr>
        <tr>
          <td class="meta-lbl">Customer Name:</td>
          <td class="meta-val">{{ customerName }}</td>
        </tr>
        {% if customerPhone %}
          <tr>
            <td class="meta-lbl">Contact:</td>
            <td class="meta-val">{{ customerPhone }}</td>
          </tr>
        {% endif %}
        {% if customerAddress %}
          <tr>
            <td class="meta-lbl">Address:</td>
            <td class="meta-val">{{ customerAddress }}</td>
          </tr>
        {% endif %}
        {% if vehicleNo %}
          <tr>
            <td class="meta-lbl">Vehicle No:</td>
            <td class="meta-val">{{ vehicleNo }}</td>
          </tr>
        {% endif %}
      </tbody>
    </table>
    <hr class="meta-divider"/>
    {% if productItems.length > 0 %}
      <table class="items-table">
        <thead>
          <tr>
            <th class="col-item">Item</th>
            <th class="col-price">Price</th>
            <th class="col-qty">Qty</th>
            <th class="col-val">Value</th>
          </tr>
        </thead>
        <tbody>
          {% for item in productItems %}
            <tr class="item-name-row">
              <td class="item-name-cell" colspan="4">
                <span class="item-num">{{ loop.index }}.</span>
                {{ item.product_name or item.item_name or "Product" }} <br/>
                {# {% if item.batch_no %}
                                <small>({{ item.batch_no }})</small>
                              {% endif %} #}
              </td>
            </tr>
            <tr class="item-val-row{% if item.discount_amount > 0 %} no-border{% endif %}">
              <td></td>
              <td class="item-price-cell">{{ item.price | formatPrice }}</td>
              <td class="item-qty-cell">
                X {{ item.quantity }}</td>
              <td class="item-val-cell">{{ item.total_price | formatPrice }}</td>
            </tr>
            {% if item.discount_amount > 0 %}
              <tr class="item-disc-row">
                <td colspan="3" class="item-disc-label">Discount:</td>
                <td class="item-disc-val">- {{ item.discount_amount | formatPrice }}</td>
              </tr>
            {% endif %}
          {% endfor %}
        </tbody>
      </table>
    {% endif %}
    {% if serviceItems.length > 0 %}
      <div class="section-header">Service Items</div>
      <table class="items-table">
        <tbody>
          {% for item in serviceItems %}
            <tr class="item-name-row">
              <td class="item-name-cell" colspan="4">
                <span class="item-num">{{ productItems.length + loop.index }}.</span>
                {{ item.product_name or item.item_name or "Service" }}
              </td>
            </tr>
            <tr class="item-val-row{% if item.discount_amount > 0 %} no-border{% endif %}">
              <td></td>
              <td class="item-price-cell">{{ item.price | formatPrice }}</td>
              <td class="item-qty-cell">{{ item.quantity }}</td>
              <td class="item-val-cell">{{ item.total_price | formatPrice }}</td>
            </tr>
            {% if item.discount_amount > 0 %}
              <tr class="item-disc-row">
                <td colspan="3" class="item-disc-label">Discount:</td>
                <td class="item-disc-val">- {{ item.discount_amount | formatPrice }}</td>
              </tr>
            {% endif %}
          {% endfor %}
        </tbody>
      </table>
      <div class="section-total-row">
        <span>Service Total:</span>
        <span>{{ serviceTotal | formatPrice }}</span>
      </div>
    {% endif %}
    {% if hasReturns %}
      <div class="section-header">Returns / Exchanges</div>
      <table class="items-table">
        <tbody>
          {% for ret in returns %}
            {% for item in ret.items %}
              <tr class="item-name-row">
                <td class="item-name-cell" colspan="4">
                  <span class="item-num">{{ loop.index }}.</span>
                  {{ item.product_name }}
                  {% if item.is_tempory_item %}
                    [EXCHANGE]{% endif %}
                  {% if item.return_type_name %}
                    <small>
                      ({{ item.return_type_name }})</small>
                  {% endif %}
                </td>
              </tr>
              <tr class="item-val-row no-border">
                <td></td>
                <td class="item-price-cell">{{ item.price | formatPrice }}</td>
                <td class="item-qty-cell">X {{ item.quantity }}</td>
                <td class="item-val-cell">{{ item.total_refund | formatPrice }}</td>
              </tr>
            {% endfor %}
          {% endfor %}
        </tbody>
      </table>
      {% for ret in returns %}
        <div class="section-total-row">
          <span>Return {{ ret.return_no }} ({{ ret.refund_type_name or "Return" }})</span>
          <span>{{ currency }}
            {{ ret.total_returned | formatPrice }}</span>
        </div>
      {% endfor %}
    {% endif %}
    <hr class="meta-divider"/>
    <div class="summary">
      {% if showProductSubtotal and serviceItems.length > 0 %}
        <div class="row">
          <span>Parts Total</span>
          <span>{{ productSubtotal | formatPrice }}</span>
        </div>
      {% endif %}
      {% if showDisc %}
        <div class="row">
          <span>Discount</span>
          <span>- {{ discountAmount | formatPrice }}</span>
        </div>
      {% endif %}
      {% if showExch %}
        <div class="row">
          <span>Exchange Disc:<span style="margin-left: 2px;">
              {% if exchangeSourceNo %}
                {{ exchangeSourceNo }}
              {% endif %}
            </span>
          </span>
          <span>- {{ exchangeAmount | formatPrice }}</span>
        </div>
      {% endif %}
      {% if showChg %}
        <div class="row">
          <span>Other Charges</span>
          <span>{{ otherCharges | formatPrice }}</span>
        </div>
      {% endif %}
      <div class="row grand">
        <span>GRAND TOTAL</span>
        <span>{{ currency }}
          {{ grandTotal | formatPrice }}</span>
      </div>
      <hr class="dashes"/>
      {% if payments.length > 0 %}
        <div class="pay-section">
          <h4>Payments Logged</h4>
          {% for p in payments %}
            <div class="row" style="font-weight: 600; padding-bottom: 0; margin-bottom: 0;">
              <span>{{ p.payment_method_name or p.payment_method_code or "Payment" }}</span>
              <span>{{ currency }}
                {{ p.amount | formatPrice }}</span>
            </div>
            <div style="font-size: 0.8em; color: #777; padding: 0 4px 2px 4px; text-align: left;">
              {{ (p.created_at or p.payment_date or dateStr) | dateTimeFormat }}
            </div>
            {% if p.payment_method_code == "cheque" or p.cheque_no %}
              <div style="font-size: 0.8em; color: #555; padding: 1px 4px 4px 4px; text-align: left; line-height: 1.3;">
                <div>Cheque No: {{ p.cheque_no or "-" }}</div>
                <div>Bank Name: {{ p.bank_name or p.cheque_bank_name or "-" }}</div>
                <div>Cheque Date: {{ p.cheque_date or "-" }}</div>
              </div>
            {% elif p.payment_method_code == "card" or p.payment_method_code == "bank_transfer" or p.transaction_no %}
              <div style="font-size: 0.8em; color: #555; padding: 1px 4px 4px 4px; text-align: left; line-height: 1.3;">
                {% if p.transaction_no %}
                  <div>Tx Ref: {{ p.transaction_no }}</div>
                {% endif %}
                {% if p.bank_name or p.deposit_bank_name %}
                  <div>Bank: {{ p.bank_name or p.deposit_bank_name }}</div>
                {% endif %}
              </div>
            {% endif %}
          {% endfor %}
        </div>
      {% endif %}
      <div class="row paid">
        <span>Total Paid</span>
        <span>{{ currency }}
          {{ paidAmount | formatPrice }}</span>
      </div>
      {% if chequePaid > 0 %}
        <div class="row">
          <span>Cheques (Uncleared)</span>
          <span>{{ currency }}
            {{ chequePaid | formatPrice }}</span>
        </div>
      {% endif %}
      {% if creditAmount > 0 %}
        <div class="row due" style="color: #c5221f;">
          <span>Credit (Balance Due)</span>
          <span>{{ currency }}
            {{ creditAmount | formatPrice }}</span>
        </div>
      {% endif %}
    </div>
    <div class="ftr">
      {% if footer %}
        <p>{{ footer }}</p>
      {% endif %}
      <p style="margin-top:4px;font-size:0.85em">Powered by TaproDev POS</p>
    </div>
  </div>
{% endif %}`;

export const CLASSIC_CSS = `@import url("https://fonts.googleapis.com/css2?family=Noto+Sans:wght@400;600;700&display=swap");

*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: "Courier New", Courier, monospace;
  font-size: var(--inv-font, 12px);
  color: #000;
  background: #fff;
  padding: var(--inv-body-pad, 0);
  line-height: 1.4;
}

.wrap {
  width: var(--inv-width, 210mm);
  max-width: 100%;
  margin: 0 auto;
  background: #fff;
  padding: var(--inv-pad, 8mm 10mm);
}

/* ── Status badge ──────────────────────────────────────── */
.status-badge {
  text-align: center;
  font-size: 0.95em;
  font-weight: 700;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
  text-transform: uppercase;
}

/* ── Header ────────────────────────────────────────────── */
.hdr {
  text-align: center;
  margin-bottom: 4px;
}

.hdr-logo {
  display: block;
  max-height: 64px;
  max-width: 160px;
  object-fit: contain;
  margin: 0 auto 2px;
}

.store-name {
  font-size: var(--inv-h2-size, 1.2em);
  font-weight: 700;
  letter-spacing: 0.2px;
}

.hdr p {
  font-size: 0.88em;
  line-height: 1.4;
}

.hdr-divider {
  border: none;
  border-top: 2px solid #000;
  margin: 4px 0;
}

/* ── Meta table ────────────────────────────────────────── */
.meta-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.88em;
  margin-bottom: 2px;
}

.meta-table td {
  padding: 1.5px 0;
  vertical-align: top;
  line-height: 1.2;
}

.meta-table td.meta-lbl {
  font-weight: 400;
  width: 42%;
  white-space: nowrap;
}

.meta-table td.meta-val {
  font-weight: 700;
  text-align: right;
}

.meta-divider {
  border: none;
  border-top: 1px dashed #000;
  margin: 4px 0;
}

/* ── Items table ───────────────────────────────────────── */
.items-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.88em;
  margin: 0;
}

.items-table thead tr {
  background: #fff;
}

.items-table thead th {
  padding: 4px 4px;
  font-weight: 700;
  border-bottom: 1px dashed #000;
  border-top: 1px dashed #000;
  white-space: nowrap;
}

.items-table thead th.col-item {
  text-align: left;
}
.items-table thead th.col-price {
  text-align: right;
}
.items-table thead th.col-qty {
  text-align: center;
}
.items-table thead th.col-val {
  text-align: right;
}

/* Two-row item layout */
.items-table tr.item-name-row td {
  padding: 0 4px 0 4px;
  font-weight: 400;
  vertical-align: top;
}

.items-table tr.item-val-row td {
  padding: 0 4px 4px 4px;
  border-bottom: 1px dashed #ccc;
  vertical-align: top;
}

.items-table tr.item-disc-row td {
  padding: 0 4px 4px 4px;
  font-size: 0.82em;
  color: #555;
}

.items-table tr.item-disc-row td {
  border-bottom: 1px dashed #ccc;
}

.item-disc-label {
  text-align: right;
  font-style: italic;
}

.item-disc-val {
  text-align: right;
  font-style: italic;
}

.items-table tr.item-val-row:last-child td,
.items-table tr.item-val-row.no-border td {
  border-bottom: none;
}

.item-num {
  font-weight: 400;
  margin-right: 2px;
}

.item-name-cell {
  text-align: left;
}

.item-price-cell {
  text-align: right;
}
.item-qty-cell {
  text-align: center;
}
.item-val-cell {
  text-align: right;
}

/* ── Section separator ─────────────────────────────────── */
.section-header {
  text-align: center;
  font-weight: 700;
  font-size: 0.85em;
  letter-spacing: 0.5px;
  padding: 4px 0;
  border-top: 1px dashed #000;
  border-bottom: 1px dashed #000;
  text-transform: uppercase;
  margin: 2px 0;
}

/* ── Section total row ─────────────────────────────────── */
.section-total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 700;
  font-size: 0.9em;
  padding: 3px 4px;
  border-top: 1px dashed #000;
}

/* ── Summary rows ──────────────────────────────────────── */
.summary {
  margin-top: 2px;
  font-size: 0.88em;
}

.row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px 4px;
  gap: 8px;
}

.row.grand {
  font-weight: 700;
  font-size: var(--inv-grand-size, 1em);
  border-top: 2px solid #000;
  border-bottom: 2px solid #000;
  padding: 4px 4px;
  margin-top: 2px;
}

.row.paid {
  font-weight: 600;
}
.row.due {
  font-weight: 600;
}

.dashes {
  border-top: 1px dashed #000;
  margin: 3px 0;
}

/* ── Payment section ───────────────────────────────────── */
.pay-section {
  margin: 4px 0;
  font-size: 0.88em;
}

.pay-section h4 {
  font-weight: 700;
  font-size: 0.82em;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 2px;
}

/* ── Footer ────────────────────────────────────────────── */
.ftr {
  text-align: center;
  margin-top: var(--inv-ftr-mt, 10px);
  border-top: 1px solid #000;
  padding-top: 5px;
  font-size: var(--inv-ftr-size, 0.82em);
  line-height: 1.5;
}

.ftr p + p {
  margin-top: 2px;
}

@media print {
  body {
    background: #fff;
    padding: 0;
  }
  .wrap {
    box-shadow: none;
    border-radius: 0;
    width: 100% !important;
  }
  @page {
    size: var(--inv-page-size, A4);
    margin: 2mm;
  }
}

/* ── A4 Invoice Layout Styles ────────────────────────── */
.a4-container {
  display: flex;
  flex-direction: column;
  font-family: Arial, Helvetica, sans-serif;
  color: #000;
  background: #fff;
  width: 100%;
}

.a4-hdr-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.a4-hdr-left {
  width: 50%;
  flex: 0 0 50%;
}

.a4-hdr-logo-img {
  max-height: 80px;
  max-width: 100%;
  object-fit: contain;
}

.a4-hdr-right-store {
  width: 50%;
  flex: 0 0 50%;
  text-align: right;
}

.a4-hdr-right-store .store-title {
  font-size: 1.5em;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.a4-hdr-right-store p {
  font-size: 0.9em;
  margin: 2px 0;
  color: #333;
}

.a4-meta-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1.5px solid #000;
  border-bottom: 1.5px solid #000;
  padding: 8px 10px;
  margin-bottom: 20px;
  background-color: #f8f9fa;
  font-size: 0.9em;
}

.a4-meta-col {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.a4-meta-col.text-right {
  align-items: flex-end;
}

.a4-meta-lbl {
  font-size: 0.78em;
  text-transform: uppercase;
  color: #555;
  letter-spacing: 0.5px;
}

.a4-meta-val {
  font-size: 0.95em;
  color: #000;
}

.a4-cust-card {
  margin: 10px 0 20px 0;
  font-size: 0.95em;
}

.a4-cust-grid {
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 4px 10px;
}

.a4-cust-lbl {
  font-weight: 500;
  color: #333;
}

.a4-cust-val {
  font-weight: 700;
  text-transform: uppercase;
}

.a4-items-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  font-size: 0.95em;
}

.a4-items-table th,
.a4-items-table td {
  border: 1px solid #888;
  padding: 8px 10px;
}

.a4-items-table th {
  background-color: #f2f2f2;
  font-weight: 700;
  text-transform: uppercase;
}

.a4-col-no { width: 6%; text-align: center; }
.a4-col-desc { width: 54%; text-align: left; }
.a4-col-price { width: 14%; text-align: right; }
.a4-col-qty { width: 10%; text-align: center; }
.a4-col-amount { width: 16%; text-align: right; }

.a4-item-row td {
  vertical-align: middle;
}

.a4-item-row .a4-desc-cell {
  text-align: left;
}

.a4-item-row .a4-price-cell {
  text-align: right;
}

.a4-item-row .a4-qty-cell {
  text-align: center;
}

.a4-item-row .a4-amount-cell {
  text-align: right;
  font-weight: 500;
}

.a4-item-disc-row td {
  padding: 4px 10px;
  font-size: 0.88em;
  background-color: #fafafa;
}

.a4-item-disc-label {
  text-align: right;
  font-style: italic;
}

.a4-item-disc-val {
  text-align: right;
  font-style: italic;
}

/* ── Modern Summary Section ── */
.a4-summary-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 20px;
  gap: 30px;
}

.a4-summary-left-card {
  width: 45%;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #dee2e6;
  padding: 15px;
}

.a4-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 8px;
  margin-bottom: 8px;
}

.a4-info-row:last-child {
  border-bottom: none;
  padding-bottom: 0;
  margin-bottom: 0;
}

.a4-info-label {
  color: #495057;
  font-weight: 500;
  font-size: 0.9em;
}

.a4-info-value {
  font-weight: 700;
  color: #212529;
  font-size: 0.9em;
}

.payment-badge {
  text-transform: uppercase;
  background-color: #e9ecef;
  padding: 2px 8px;
  border-radius: 4px;
}

.status-badge-a4 {
  padding: 3px 10px;
  border-radius: 12px;
  font-weight: 700;
  font-size: 0.85em;
  text-transform: uppercase;
}

.status-badge-a4.ordered,
.status-badge-a4.paid,
.status-badge-a4.fully_paid {
  background-color: #e9ecef;
  color: #212529;
}

.status-badge-a4.unpaid,
.status-badge-a4.overdue {
  background-color: #e9ecef;
  color: #212529;
}

.status-badge-a4.partially_paid {
  background-color: #e9ecef;
  color: #212529;
}

.a4-summary-right-totals {
  width: 45%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: right;
}

.a4-total-row {
  display: flex;
  justify-content: space-between;
  font-size: 0.95em;
  color: #495057;
}

.a4-exch-src {
  font-style: italic;
  font-size: 0.8em;
  color: #868e96;
  font-weight: 400;
}

.a4-grand-total-row {
  display: flex;
  justify-content: space-between;
  border-top: 2px solid #212529;
  padding-top: 10px;
  margin-top: 5px;
}

.a4-grand-lbl {
  font-weight: 700;
  font-size: 1.15em;
  color: #212529;
}

.a4-grand-val {
  font-weight: 700;
  font-size: 1.15em;
  color: #212529;
}

/* ── Payments Section ── */
.a4-payments-section {
  margin-top: 25px;
}

.a4-sec-title {
  font-size: 1.05em;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 12px;
  border-bottom: 2px solid #dee2e6;
  padding-bottom: 6px;
  color: #212529;
}

.a4-payments-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  margin-bottom: 20px;
}

.a4-payments-table th {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  padding: 8px 12px;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.85em;
  color: #495057;
  text-align: left;
}

.a4-payments-table td {
  border: 1px solid #dee2e6;
  padding: 10px 12px;
  vertical-align: top;
  font-size: 0.9em;
  color: #212529;
}

.a4-payments-table tr:nth-child(even) td {
  background-color: #fcfcfc;
}

.a4-signature-section {
  display: flex;
  justify-content: space-between;
  margin-top: 60px;
  margin-bottom: 20px;
  padding: 0 15px;
}

.a4-sig-block {
  width: 220px;
  text-align: center;
}

.a4-sig-line {
  border-top: 1px solid #333;
  margin-bottom: 6px;
}

.a4-sig-label {
  font-size: 0.85em;
  font-weight: 600;
  color: #495057;
}

.a4-ftr {
  text-align: center;
  margin-top: 40px;
  font-size: 0.9em;
  line-height: 1.5;
}

.a4-ftr-note {
  font-style: italic;
  margin-bottom: 6px;
}

.a4-ftr-thank {
  font-weight: 700;
  font-size: 1.05em;
}

.a4-ftr-powered {
  margin-top: 8px;
  font-size: 0.8em;
  color: #777;
}


.qr80-ref {
  font-size: 0.72em;
  color: #555;
}

`;
